import { isServerSide } from "../isServerSide";

export const getCSSCustomProperty = (property: string, fallback?: number): number | undefined => {
  if (isServerSide()) return fallback;
  const parsed = parseInt(getComputedStyle(document.documentElement).getPropertyValue(property), 10);
  return isNaN(parsed) ? fallback : parsed;
};
